<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5 class="card-title">Einweisungen {{ dateFilterFormatted }}</h5>
          </div>
          <div class="col-md-auto">
            <el-date-picker
              v-model="dateFilter"
              type="date"
              placeholder="Datum wählen"
              :picker-options="pickerOptionsHeader"
              format="dd.MM.yyyy"
              @change="loadEinweisungen"
            >
            </el-date-picker>
          </div>
          <div class="col-md-auto text-right">
            <!-- disable button of dateFilter is not today -->
            <p-button type="success" @click="newEinweisung" class="mt-0" :disabled="dateFilterFormatted !== todayFormatted"><i class="bi bi-file-earmark-plus"></i> Neue Einweisung</p-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-4 pb-3 pt-2">
          <div class="col-sm-4">
            <el-statistic title="Einweisungen" :value=einweisungenCount group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-sm-4">
            <el-statistic title="Teilnehmer" :value=einweisungenPersons group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-sm-4">
            <el-statistic title="Durschschn. Teilnehmer" :value=einweisungenAvgPersons group-separator="." decimal-separator="," :precision="0"></el-statistic>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-sm-12">
            <el-table
              :data="einweisungen"
              header-row-class-name="text-primary"
              empty-text="Es konnten keine Einweisungen gefunden werden."
              :default-sort = "{prop: 'StartTimeRaw', order: 'descending'}"
            >
              <el-table-column prop="StartTimeFormatted" label="Startzeit"> </el-table-column>  
              <el-table-column prop="attendees" label="Teilnehmer"> </el-table-column>
              <el-table-column prop="parcours" label="Parcours"> </el-table-column>
              <el-table-column prop="Trainer" label="Mitarbeiter"> </el-table-column>
              <el-table-column label="" width="150">
                <template slot-scope="scope">
                  <p-button type="primary" size="small" @click="editEinweisung(scope.row)" title="Bearbeiten"><i class="bi bi-pencil-square"></i></p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Neue Einweisung Modal -->
    <el-dialog :title=" dialogMode === 'create' ? 'Neue Einweisung' : 'Einweisung bearbeiten'" :visible.sync="newEinweisungDialog" :close-on-click-modal="false">
      <el-form :model="newEinweisungForm">
        <div class="row">
          <div class="col-md-6">
              <el-form-item label="Startzeit">
                <el-time-picker
                  v-model="newEinweisungStartTime"
                  :picker-options="{ selectableRange: '08:00:00 -22:00:00' }"
                  placeholder="Startzeit wählen"
                  format="HH:mm"
                  :arrow-control="true"
                >
                </el-time-picker>
              </el-form-item>
          </div>
          <div class="col-md-6">
              <el-form-item label="Anzahl der Teilnehmer">
                <el-input-number
                  v-model="newEinweisungAttendees"
                  :min="1"
                  :max="1000"
                  label="Anzahl der Teilnehmer"
                  class="w-100"
                >
                </el-input-number>
              </el-form-item>
          </div>
        </div>
        <div class="row">
          
        </div>
        <div class="row">
          <div class="col-md-6">
            <el-form-item label="Parcours">
              <el-select
                    class="select"
                    placeholder="Parcours wählen"
                    filterable
                    v-model="newEinweisungParcours"
                  >
                    <el-option
                      v-for="option in parcoursEinweisungen"
                      class="select"
                      :value="option.parcoursName"
                      :label="option.parcoursName"
                      :key="option.key"
                    >
                    </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="Mitarbeiter">
              <el-select
                    class="select"
                    placeholder="Mitarbeiter wählen"
                    filterable
                    v-model="newEinweisungTrainer"
                  >
                    <el-option
                      v-for="option in staff"
                      class="select"
                      :value="option.staffName"
                      :label="option.staffName"
                      :key="option.staffName"
                    >
                    </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="newEinweisungDialog = false">Abbrechen</p-button>
        <p-button type="primary" @click="addEinweisung" :disabled="!newEinweisungAttendees || !newEinweisungParcours || !newEinweisungStartTime || !newEinweisungTrainer" v-if="dialogMode === 'create'">Speichern</p-button>
        <p-button type="primary" @click="updateEinweisung" :disabled="!newEinweisungAttendees || !newEinweisungParcours || !newEinweisungStartTime || !newEinweisungTrainer" v-if="dialogMode === 'edit'">Speichern</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox, Dialog, Form, FormItem, Statistic } from "element-ui";
import router from "../../../../main";
import moment, { now } from "moment-timezone";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(Statistic);

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },

  data() {
    return {
      einweisungen: [],
      staff: [],
      einweisungenCount: 0,
      einweisungenPersons: 0,
      einweisungenAvgPersons: 0,
      parcoursEinweisungen: [],
      dateFilter: new Date(this.$route.params.date || Date.now()),
      dateFilterFormatted: moment(this.$route.params.date || Date.now()).format('DD. MMM YYYY'),
      todayFormatted: moment(new Date()).format('DD. MMM YYYY'),
      newEinweisungAttendees: 0,
      newEinweisungParcours: null,
      newEinweisungStartTime: null,
      newEinweisungTrainer: null,
      newEinweisungForm: {},
      editEinweisungKey: null,
      newEinweisungDialog: false,
      dialogMode: "create",
      location: store.getters.userlocation,
      role: store.getters.userrole,
      pickerOptionsHeader: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Heute",
            onClick(picker) {
              const date = new Date();
              picker.$emit("pick", date);
            },
          },
          {
            text: "Gestern",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
        ],
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions1: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Morgen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Woche",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 2 Wochen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Monat",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    moment.locale("de");
    this.loadEinweisungen();
    this.getStaff();
    this.getParcoursEinweisungen();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadEinweisungen();
        this.getStaff();
        this.getParcoursEinweisungen();
      }
    );
  },
  methods: {
    loadEinweisungen() {
      let start, end;
      if (this.dateFilter) {
        this.dateFilterFormatted = moment(this.dateFilter).format('DD. MMM YYYY');
        start = new Date(this.dateFilter)
        end = new Date(this.dateFilter)
      } else {
        this.dateFilter = new Date();
        this.dateFilterFormatted = moment(this.dateFilter).format('DD. MMM YYYY');
        start = new Date()
        end = new Date()
      }
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      const einweisungenRef = db.collection("safetyBriefings");
      einweisungenRef.where('locationID', '==', this.location).where('StartTime', '>=', start).where('StartTime', '<=', end).orderBy("StartTime", "desc").onSnapshot((snapshotChange) => {
        this.einweisungen = [];
        snapshotChange.forEach((doc) => {
          this.einweisungen.push({
            key: doc.id,
            attendees: doc.data().Attendees,
            parcours: doc.data().Parcours,
            StartTimeRaw: doc.data().StartTime,
            StartTimeFormatted: doc.data().StartTime ? moment(new Date(doc.data().StartTime.seconds * 1000)).format("HH:mm").toString() : "-",
            Trainer: doc.data().Trainer,
            uid: doc.data().uid,
          });
        });
        this.einweisungenCount = this.einweisungen.length;
        this.einweisungenPersons = this.einweisungen.reduce((total, einweisung) => total + einweisung.attendees, 0);
        if (this.einweisungenCount > 0) {
          this.einweisungenAvgPersons = Math.round(this.einweisungenPersons / this.einweisungenCount * 10) / 10;
        } else {
          this.einweisungenAvgPersons = 0;
        }
      });
    },
    getStaff() {
      // get list of staff
      const staffRef = db.collection("trainer");
      staffRef
        .where("isToday", "==", true)
        .where("isTodayLocation", "==", this.location)
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.staff = [];
          snapshotChange.forEach((doc) => {
            this.staff.push({
              staffName: doc.data().Name,
            });
          });
        });
    },
    getParcoursEinweisungen() {
      const parcoursRef = db.collection("trainingParcours");
      parcoursRef
        .where("locationID", "==", this.location)
        .orderBy("parcoursID")
        .onSnapshot((snapshotChange) => {
          this.parcoursEinweisungen = [];
          snapshotChange.forEach((doc) => {
            this.parcoursEinweisungen.push({
              key: doc.id,
              parcoursName: doc.data().parcoursID,
            });
          });
        });
    },
    newEinweisung() {
      this.dialogMode = "create";
      this.newEinweisungDialog = true;
      this.newEinweisungAttendees = 0;
      this.newEinweisungParcours = null;
      this.newEinweisungStartTime = new Date();
      this.newEinweisungTrainer = null;
    },
    editEinweisung(einweisung) {
      this.dialogMode = "edit";
      this.newEinweisungAttendees = einweisung.attendees;
      this.newEinweisungParcours = einweisung.parcours;
      this.newEinweisungStartTime = new Date(einweisung.StartTimeRaw.seconds * 1000);
      this.newEinweisungTrainer = einweisung.Trainer;
      this.editEinweisungKey = einweisung.key;
      this.newEinweisungDialog = true;
    },
    addEinweisung() {
      db.collection("safetyBriefings")
        .add({
          Attendees: this.newEinweisungAttendees,
          Parcours: this.newEinweisungParcours,
          StartTime: this.newEinweisungStartTime,
          Trainer: this.newEinweisungTrainer,
          CreatedAt: new Date(),
          locationID: this.location,
        })
        .then(() => {
          this.newEinweisungAttendees = 0;
          this.newEinweisungParcours = null;
          this.newEinweisungStartTime = null;
          this.newEinweisungTrainer = null;
          this.newEinweisungDialog = false;
          console.log("Einweisung added.");
        })
        .catch(() => {
          console.log("Adding einweisung failed");
        });
    },
    updateEinweisung() {
      db.collection("safetyBriefings")
        .doc(this.editEinweisungKey)
        .update({
          Attendees: this.newEinweisungAttendees,
          Parcours: this.newEinweisungParcours,
          StartTime: this.newEinweisungStartTime,
          Trainer: this.newEinweisungTrainer,
          LastUpdated: new Date(),
        })
        .then(() => {
          this.newEinweisungAttendees = 0;
          this.newEinweisungParcours = null;
          this.newEinweisungStartTime = null;
          this.newEinweisungTrainer = null;
          this.editEinweisungKey = null;
          this.newEinweisungDialog = false;
          console.log("Einweisung updated.");
        })
        .catch(() => {
          console.log("Updating einweisung failed");
        });
    },
  },
};
</script>
<style>
  .el-form-item__label {
    font-weight: bold;
    line-height: normal !important;
  }
</style>
